import { Component, OnInit } from '@angular/core';
import { AppService, DentalBidirectionalList, DentalBidirectionalListItem, GetDentalBidirectionalListsRequest, SaveListItemOrderRequest } from '../../app.service';
import { AlertService } from '../../common/alert.service';
import { LoadingService } from '../../common/loading.service';
import { MatDialog } from '@angular/material/dialog';
import { catchError, finalize, of, tap } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ListItemEditDialogComponent } from './list-item-edit-dialog/list-item-edit-dialog.component';

@Component({
  selector: 'app-list-admin',
  templateUrl: './list-admin.component.html',
  styleUrl: './list-admin.component.scss'
})
export class ListAdminComponent implements OnInit {


  public dentalBidirectionalLists: DentalBidirectionalList[] = [];
  public selectedPreviewListItems: DentalBidirectionalListItem[] = [];
  public visibleListItems: DentalBidirectionalListItem[] = [];
  public dentalBidirectionalListsDataSource: MatTableDataSource<DentalBidirectionalList> = null;
  public dentalBidirectionalListsDisplayColumns: string[] = ['Name', 'Description', 'Action'];
  public selectedList: DentalBidirectionalList = null;
  public showInactive: boolean = false;

  constructor(
    private service: AppService,
    private alert: AlertService,
    private spinner: LoadingService,
    private dialog: MatDialog,
  ) { }


  ngOnInit(): void {
    this.loadLists();
  }

  private loadLists() {
    const request = new GetDentalBidirectionalListsRequest();

    // Show the spinner before the request starts
    this.spinner.show();

    this.service.GetDentalBidirectionalLists(request).pipe(
      tap((result) => {
        if (result.success) {
          this.dentalBidirectionalLists = result.lists;
          this.dentalBidirectionalListsDataSource = new MatTableDataSource(result.lists);
        } else {
          console.log(`ERROR: ${result.message}`);
        }
      }),
      catchError((error) => {
        console.error(error);
        return of([]); // Return an empty array or appropriate fallback in case of error
      }),
      finalize(() => {
        // Hide the spinner after the request completes, whether it was successful or not
        this.spinner.hide();
      })
    ).subscribe();
  }
  
  public editList(list: DentalBidirectionalList) {
    this.selectedList = list;
    this.updatePreviewListItems();
  }


  public toggleActiveListItems() {
    this.updatePreviewListItems();
  }



  public updatePreviewListItems() {
    this.selectedPreviewListItems = this.selectedList.listItems.filter(i => i.active).sort(i => i.order);
    if (this.showInactive) {
      this.visibleListItems = this.selectedList.listItems.sort(i => i.order);
    } else {

      this.visibleListItems = this.selectedList.listItems.filter(i => i.active).sort(i => i.order);
    }
  }

  public drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.selectedList.listItems, event.previousIndex, event.currentIndex);
    this.updatePreviewListItems();
  }

  public editListItem(item: DentalBidirectionalListItem) {
    const dialogRef = this.dialog.open(ListItemEditDialogComponent, { disableClose: true, data: { ListItemToUpdate: item, List: this.selectedList } })
      .afterClosed()
      .subscribe(response => {
        //refresh grid
        this.loadLists();
      });
  }

  public addNewListItem() {
    const dialogRef = this.dialog.open(ListItemEditDialogComponent, { disableClose: true, data: { List: this.selectedList } })
      .afterClosed()
      .subscribe(response => {
        //refresh grid
        this.loadLists();
      });
  }

  public sortListItems() {
    this.selectedList.listItems.sort((a, b) => a.name.localeCompare(b.name));
    this.visibleListItems.sort((a, b) => a.name.localeCompare(b.name));
    this.selectedPreviewListItems.sort((a, b) => a.name.localeCompare(b.name));
  }

  public saveListOrder() {
    this.spinner.show();
    const request = new SaveListItemOrderRequest();

    this.selectedList.listItems.forEach((value, index) => {
      value.order = index + 1;
    });

    request.ListItems = this.selectedList.listItems;

    this.service.SaveListItemOrder(request).subscribe(
      response => {
        this.loadLists();
        this.alert.success('List order updated.');
        this.spinner.hide();
      },
      error => {
        this.spinner.hide();
        this.alert.errorWithDetails(error, 'Unable to save list order.');
      });
  }

  public onSaveClick() {

    this.spinner.show();

    const request = new SaveListItemOrderRequest();

    this.selectedList.listItems.forEach((value, index) => {
      value.order = index + 1;
    });

    request.ListItems = this.selectedList.listItems;

    this.service.SaveListItemOrder(request)
      .pipe(
        finalize(() => {
          // Hide the spinner after the request completes
          this.spinner.hide();
        })
      )
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.loadLists();
            this.alert.success('List order updated.');
          } else {
            this.alert.warning(response.message);
          }
        },
        error: (error) => {
          console.error('Unable to save list order:', error);
          this.alert.errorWithDetails(error, 'Unable to save list order.');
        }
      });
  }
}
